/**
 * Throws if given object is not an instance of a given type.
 * @param instance
 * @param type
 */
export function assertInstanceOf(instance,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type) {
  if (!(instance instanceof type)) {
    throw new Error("Expected instance of ".concat(type.name));
  }
}

/**
 * Throws an error if excecuted. Useful for exhaustive switch statements.
 *
 * e.g.
 * type Value = 'A' | 'B'
 *
 * declare const value: Value;
 *
 * switch(value) {
 *   case 'A':
 *     break;
 *
 *   case 'B':
 *     break;
 *
 *   default:
 *     // This case should never be hit. If it is, the types are wrong or the
 *     // runtime input is unexpected, so throw an error. Also, if we add an
 *     // additional type to Value and don't add a corresponding case in the
 *     // switch, the compiler will complain since assertNever() expects a
 *     // `never` value.
 *     assertNever(value);
 * }
 * @param shouldBeNever Value that is not expected to exist
 * @param name Optional name of the "never" value
 */
export function assertNever(shouldBeNever, name) {
  var label = name == null ? 'value' : "'".concat(name, "'");
  throw new Error("Unexpected ".concat(label, ": ").concat(shouldBeNever));
}
export function assertNotNull(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Value is null or undefined';
  if (value == null) throw new Error(message);
}
export function assertNotEmpty(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Size of value is 0';
  if (value instanceof Map) {
    if (value.size === 0) throw new Error(message);
  } else if (value.length === 0) {
    throw new Error(message);
  }
}
export function assertNotNaN(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Value is NaN';
  if (Number.isNaN(value)) throw new Error(message);
}

/**
 * Retrieve a value from a map. If the value is not found and no default value is provided, throw.
 * Use when the value _must_ be present
 * @param map The map to get the value from
 * @param key The key to fetch the value for
 * @param defaultValue A default value to set if the key is not present
 * @returns The value set for that key
 */
export function getOrThrow(map, key) {
  var _map$get;
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var value = (_map$get = map.get(key)) !== null && _map$get !== void 0 ? _map$get : defaultValue;
  if (value !== undefined) {
    return value;
  }
  throw new Error("Missing value for key ".concat(key));
}
//# sourceMappingURL=Asserts.js.map